import React from 'react';

import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import useStoreTranslation from 'hooks/useStoreTranslation';

import {
  Container,
  TitleContainer,
  Title,
  Icon,
  List,
  CloseIcon,
  Header,
  Item,
  StyledButton as Button,
  ButtonContainer,
} from './styles';

export interface Item {
  icon: string;
  text: string;
}

export interface Props {
  show: boolean;
  onClose: () => void;
  title: string;
  items: Item[];
}

const FullScreenToolTip = ({ show, onClose, title, items }: Props) => {
  const { t } = useStoreTranslation();

  return (
    <ApplicationOverlayContent show={show} onClose={onClose}>
      <Container>
        <Header>
          <CloseIcon src="/images/close-2.svg" onClick={onClose} alt="close" />
        </Header>
        <TitleContainer>
          <Icon src="/images/advice-2.svg" alt="" />
          <Title>{title}</Title>
        </TitleContainer>
        <List>
          {items.map((item, index) => (
            <Item key={index.toString()}>
              <Item.IconContainer>
                <Item.Icon src={item.icon} alt="" />
              </Item.IconContainer>
              <Item.Text>{item.text}</Item.Text>
            </Item>
          ))}
        </List>
        <ButtonContainer>
          <Button value={t('fullScreenToolTip.buttonValue')} onClick={onClose} />
        </ButtonContainer>
      </Container>
    </ApplicationOverlayContent>
  );
};

export default FullScreenToolTip;
